import { Flex, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import { NavbarFilterGroup } from '../../features/Navbar/NavbarFilterGroup'

const DrilldownHeader = ({ title }) => {
  return (
    <Flex
      bgColor="#F5F5F5"
      height="100px"
      maxH="100px">
      <Flex
        flex={1}
        m="0 24px"
        mt="-8px"
        alignItems="center"
        justifyContent="space-between">
        <Text textStyle="heading">{title}</Text>
        <NavbarFilterGroup
          mt="-8px"
          key={2}
          shouldUsePortalAtDropdown={false}
        />
      </Flex>
    </Flex>
  )
}

DrilldownHeader.propTypes = {
  title: PropTypes.string,
}

export default DrilldownHeader
